module.exports = __webpack_public_path__ + "img/header-img-v7.ef848531.jpg";